import { useParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'

import { IStorageService } from '@/services/contracts/storage'
import { queryClient } from '@/providers/libs/query-client'

type UploadProps = {
  storageService: IStorageService
}

export function useUploadImage({ storageService }: UploadProps) {
  const { id: institution_id } = useParams()

  const mutation = useMutation({
    mutationKey: ['upload_image', institution_id],
    mutationFn: (file: File) =>
      storageService.uploadImage(institution_id!, file),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['list_institution', institution_id],
      })
    },
  })

  return {
    uploadImage: mutation.mutateAsync,
    isUploading: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  }
}
